<template>
  <div>
    <top-bar :user="this.user" />
    <MenuItems :user="this.user" :menuSelected="{ membership: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ dashboard: true }" />
    </div>

    <div class="container-right">
      <div :class="{
        content: true,
      }" class="membership">
        <h1>{{ $t("membershipTitle") }}</h1>
        <p>{{ $t("membershipShortDesc") }}</p>
        <br />

        <div v-if="this.isUserPremium(user) " class="membership-succes">
          <!-- <b-carousel id="carousel-1" :interval="4000" indicators> -->

          <div class="user-premium">
            <div class="premium-icon">
              <img :src="require('@/assets/images/memberCrown.svg')" />
            </div>
          </div>
          <img class="membership-user border-round" :src="
            this.getImagePath() + 'users/user_' + this.user.person.id + '.png'
          " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
          <p v-html="$t('membershipText', { name: this.user.person.first_name })"></p>
        </div>
        <div v-else class="membership">
          <div class="membership-simple">
            <div class="membership-wrapper">
              <table>
                <tr>
                  <td rowspan="2">
                    <img class="sticker-image" :src="require('@/assets/images/diamond.svg')" />
                  </td>
                  <td>
                    <h1>60</h1>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>{{ $t("membershipBox1") }}</h5>
                  </td>
                </tr>
              </table>
            </div>
            <div class="membership-wrapper">
              <table>
                <tr>
                  <td rowspan="2">
                    <img class="sticker-image" :src="require('@/assets/images/stars.svg')" />
                  </td>
                  <td>
                    <h1>70</h1>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>{{ $t("membershipBox2") }}</h5>
                  </td>
                </tr>
              </table>
            </div>
            <div class="membership-wrapper">
              <table>
                <tr>
                  <td rowspan="2">
                    <img class="sticker-image" :src="require('@/assets/images/owl.svg')" />
                  </td>
                  <td>
                    <h5>{{ $t("membershipBox3") }}</h5>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <a class="button-all button-orange" @click="requestPremium">{{
            $t("membershipRequestButton")
          }}</a>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.userManageError">
          <p v-html="$t('error_' + this.userManageError.description)"></p>
        </div>
        <div v-else>
          <br />
          <p>{{ $t("requestPremiumSuccessMessage") }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import ModalLoading from "../components/fragments/ModalLoading.vue";
import httpServiceUser from "@/http/http-user.js";


export default {
  name: "Membership",
  components: { TopBar, MenuItems, ModalLoading },
  data() {
    return {
      user: null,
      userManageError: null
    };
  },
  methods: {
    requestPremium() {
      // this.showModalPopup("modal_popup_loading", true);
      this.user.companies[0].role_id = 5;
      httpServiceUser.userService
        .modifyUserForManageCompany(
          this.user.id,
          this.user.id,
          this.user,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.userManageError = { description: response.status };
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.userManageError = { description: error.response.status };
          } else {
            this.userManageError = { description: "undefined" };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
  },
  created() {
    this.user = this.getUser();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.membership-wrapper {
  padding: 30px;
  width: 356px;
  max-width: 370px;
  margin: 10px;
  min-height: 130px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  /* color: #eee; */
  background: #ffffff;
  /* Primary 1 */

  border: 1px solid #f19100;

  font-family: "Raleway";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* or 125% */

  /* Primary 2 */

  color: #2d3736;
}

.membership-wrapper table {
  height: 100%;
}

.membership-wrapper table img {
  padding-right: 15px;
}

.membership-wrapper table h1 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  font-size: 52px;
  line-height: 63px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* Primary 1 */

  color: #f19100;
}

.premium-icon {
  width: 52px;
  top: 70px;
  left: 55px;
  background: transparent;
}

.user-premium {
  margin: 10px;
}

.membership-succes {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 550px;
}

.membership-simple {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
